import { expandRequest } from 'reactApp/modules/integration/integration.actions';
import { store as reduxStore } from 'reactApp/store';

export const more = () => {
    reduxStore.dispatch(expandRequest());
};
